<template>
  <div>
    <master-table
      top-title="Master Referensi"
      title="Penyebab"
      :items="items"
      :fields="fields"
      @open-create-modal="openCreate"
      @open-edit-modal="openEdit"
      @open-delete-modal="openDeleteModal"
    />
    <confirm-modal
      v-model="isDeleteConfirm"
      title="Hapus data"
      msg="Apakah anda yakin akan menghapus data ini?"
      @close-modal="isDeleteConfirm = false"
      @confirm-ok="actionDelete"
    />
  </div>
</template>

<script>
import MasterTable from '@/components/MasterTable';
import ConfirmModal from '@/components/Confirm/ConfirmModal.vue';
import mixin from './mixin';

export default {
  name: 'MasterPenyebab',
  components: {
    MasterTable,
    ConfirmModal,
  },
  mixins: [mixin],
  data() {
    return {
      fields: [],
      items: null,
      idToDelete: null,
      isDeleteConfirm: false,
    };
  },
  async mounted() {
    await this.loadPenyebab();
    this.fields = [
      {
        key: 'id',
        label: 'Kode',
        _style: 'width: 15%',
      },
      {
        key: 'deskripsi',
        label: 'Deskripsi Penyebab',
        _style: 'width: 70%',
      },
    ];
    if (localStorage.level == 0 || localStorage.level == 1) {
      this.fields = [
        ...this.fields,
        {
          key: 'actions',
          _style: 'width: 15%',
        },
      ];
    }
  },
  methods: {
    openCreate() {
      this.$router.push({
        name: 'master-create-penyebab',
      });
    },
    openEdit(item) {
      this.$router.push({
        name: 'master-edit-penyebab',
        params: { idPenyebab: item.id },
      });
    },
    openDeleteModal(id) {
      this.isDeleteConfirm = true;
      this.idToDelete = id;
    },
    async actionDelete() {
      try {
        await this.$store.dispatch('m_penyebab/deletePenyebab', {
          idPenyebab: this.idToDelete,
        });

        this.isDeleteConfirm = false;

        await this.loadPenyebab();

        this.toastSuccess(
          `Berhasil menghapus data dengan ID ${this.idToDelete}`
        );
      } catch (error) {
        this.toastError(error.message);
      }
    },
    async loadPenyebab(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch('m_penyebab/loadPenyebab', {
          forceRefresh: refresh,
        });
        this.items = this.$store.getters['m_penyebab/penyebab'];
      } catch (error) {
        this.error = error.message || 'Something went wrong!';
      }
      this.loading = false;
    },
  },
};
</script>

<style>
.modal-master-detail .form-control[readonly] {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
